//
//
//
//
//
//

export default {
  name: 'app',
}



// WEBPACK FOOTER //
// ./src/App.vue